import PropTypes from 'prop-types';
import { useRef } from 'react';

import Sidebar from 'components/Sidebar';
import SidebarRules from 'components/Sidebar/SidebarRules';

const SuggestNewThreadSidebar = ({ gaEventCategory, ...rest }) => {
  const sidebarRulesRef = useRef(null);

  return (
    <Sidebar refsToBeIgnoredBeforeFixing={[sidebarRulesRef]} {...rest}>
      <SidebarRules
        ref={sidebarRulesRef}
        className="hidden xl:flex"
        gaEventCategory={gaEventCategory}
      />
    </Sidebar>
  );
};

SuggestNewThreadSidebar.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default SuggestNewThreadSidebar;
